<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Entité :</label>
        </div>
        <div class="col-4">
          <Dropdown
            v-model="entite"
            :options="entiteLibelles"
            :showClear="true"
            :filter="true"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Site :</label>
        </div>
        <div class="col-4">
          <Dropdown
            v-model="site"
            :options="siteLibelles"
            :showClear="true"
            :filter="true"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Regroupement des endroits :</label>
        </div>
        <div class="col-4">
          <Dropdown
            v-model="regroupementEndroit"
            :options="regroupementEndroitLibelles"
            :showClear="true"
            :filter="true"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div v-if="!isRechercheDataLoading" class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div v-else class="col">      
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
    <div class="col" >
      <Button @click="redirectionAjouter"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  props: ['isRechercheDataLoading'],
  emits: ['rechercher'],

  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('pilotage/rechercherListeEntiteAction')
    .then((res) => {
        this.entiteLibelles = res.data;
    });
    this.$store.dispatch('pilotage/obtenirRegroupementsEndroitsAction')
    .then((res) => {
      this.regroupementEndroitLibelles = res.data;
    })
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      entiteLibelles: [],
      entite: null,
      siteLibelles: [],
      site: null,
      regroupementEndroitLibelles: [],
      regroupementEndroit: null,
    }
  },
  methods: {
    rechercher() {
      let criteres = {};
      criteres.entiteCle = this.entite;
      criteres.siteCle = this.site;
      criteres.regroupementEndroitCle = this.regroupementEndroit;
      this.$emit("rechercher", criteres);
    },
    redirectionAjouter(){
      this.$router.push({name: "ajouterEndroit"});
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  },
  watch: {
    entite(val) {
      if (val != null) {
        this.$store.dispatch('dossier/onChangeEntityAction', {
          libelleChange: 'Site',
          nouvelleValeur: [val]
        })
        .then((res) => {
          this.siteLibelles = res.data;
          this.site = null;
        });
      }else {
        this.site = null;
        this.siteLibelles = [];
      }
    }
  }
}
</script>
